import { z } from 'zod';
const productNameSchema = z.enum(['Growth', 'ECommerce']);
const productEntitySchema = z.object({
    id: z.number(),
    name: productNameSchema,
    url: z.string()
});
const productEntityToCreateSchema = productEntitySchema.omit({ id: true });
export { productEntitySchema, productEntityToCreateSchema };
//# sourceMappingURL=projects.product.model.js.map